import { render, staticRenderFns } from "./booklistBox.vue?vue&type=template&id=1410f3ed&scoped=true&"
import script from "./booklistBox.vue?vue&type=script&lang=js&"
export * from "./booklistBox.vue?vue&type=script&lang=js&"
import style0 from "./booklistBox.vue?vue&type=style&index=0&id=1410f3ed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410f3ed",
  null
  
)

export default component.exports